import classNames from 'classnames'

import { ButtonCopy } from '@apps-common/components/elements/button/ButtonCopy'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { useIonModal } from '@ionic/react'
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces'

interface IProps {
  label: string
  value: string
  Modal: any
  modalProps: any
  modalSuccessCallback?: () => void
  allowCopy?: boolean
  callbackDisabled?: boolean
  callbackHidden?: boolean
  callback?: () => void
  loading?: boolean
  classes?: string
}

export const DetailsItemModalAction: React.FC<IProps> = ({
  label,
  value,
  Modal,
  modalProps,
  modalSuccessCallback,
  allowCopy,
  callbackDisabled,
  callbackHidden,
  callback,
  loading,
  classes
}) => {
  const [present, dismiss] = useIonModal(Modal, {
    componentProps: modalProps,
    onDismiss: (data: string, role: string) => dismiss(data, role),
    enableBackdropDismiss: false
  })

  return (
    <>
      {loading && (
        <div className='animate-pulse'>
          <div className='h-[18px] w-[60%] bg-skeleton rounded mb-[4px]' />
          <div className='h-[24px] w-[40%] bg-skeleton rounded' />
        </div>
      )}
      {!loading && (
        <div className={classes}>
          <div className='jost text-[0.8em] sm:text-[0.9em] text-text-muted'>{label}</div>
          <div className='text-[0.85em] sm:text-[1em] jost-light text-text flex items-center text-nowrap'>
            {callbackHidden && <div className='text-ellipsis overflow-hidden'>{value}</div>}
            {!callbackHidden && (
              <button
                type='button'
                aria-label='Action button'
                disabled={callbackDisabled}
                className={classNames(!callbackDisabled && 'hover:opacity-70', 'flex items-center justify-start max-w-[90%]')}
                onClick={() => {
                  present({
                    enterAnimation: modalSlideUpEnterAnimation,
                    leaveAnimation: modalSlideUpLeaveAnimation,
                    backdropDismiss: false,
                    onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
                      if (ev.detail.role === ModalDismiss.Confirm && modalSuccessCallback) {
                        modalSuccessCallback()
                      }
                    }
                  })
                }}
              >
                <div className='text-ellipsis overflow-hidden'>{value}</div>
                <div className={classNames(callbackDisabled && 'opacity-30', 'ml-[5px] rounded-full p-[1px] border border-text-muted')}>
                  <commonIcons.arrowAngled className='text-[0.85em]' />
                </div>
              </button>
            )}
            {allowCopy && <ButtonCopy value={value} />}
          </div>
        </div>
      )}
    </>
  )
}
